import { createSvgIcon } from '@automata/mui-theme';
export const TecanSparkIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.9062 65.3198C28.5768 65.1243 28.1647 65.134 27.8449 65.345L18.3321 71.6208C17.7159 72.0273 17.7375 72.9385 18.3723 73.3153L29.0923 79.6804C29.4217 79.8759 29.8338 79.8662 30.1536 79.6552L39.6664 73.3794C40.2826 72.9729 40.261 72.0618 39.6262 71.6849L28.9062 65.3198ZM28.4515 68.5388L22.65 72.3663L29.547 76.4614L35.3485 72.634L28.4515 68.5388Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82 32.8174V60.0536L45.8613 81.5251L35.8513 75.7661L33.0645 77.6239L45.3789 84.7086C45.692 84.8887 46.0779 84.886 46.3884 84.7015L84.5108 62.0514C84.8141 61.8712 85 61.5445 85 61.1917V31.6904C85 31.3406 84.8172 31.0162 84.518 30.835L50.6157 10.3038C50.3061 10.1163 49.9193 10.1108 49.6044 10.2893L11.5067 31.8959C11.1935 32.0735 11 32.4057 11 32.7657V64.3514C11 64.7092 11.1912 65.0397 11.5013 65.2181L22.8658 71.7564L25.6525 69.8986L14 63.1946V33.9307L50.0645 13.4773L82 32.8174Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M45 83V54H47V83H45Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.4746 54.8508L11.4746 33.8508L12.5256 32.1492L46.5256 53.1492L45.4746 54.8508Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.5104 32.8595L46.5104 54.8595L45.4883 53.1404L82.4883 31.1404L83.5104 32.8595Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.5029 24.365L32.5029 45.865L31.498 44.1357L68.498 22.6357L69.5029 24.365Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.5033 50.865L45.9967 72.6594L12.4922 52.8613L13.5096 51.1394L46.0052 70.3413L82.4985 49.1357L83.5033 50.865Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36 62C35.2661 60.9138 34.3377 59.6021 33.2603 58.1541C28.6984 52.0229 21.4638 43.4467 15 39.1875C14.3236 38.7418 13.6556 38.3434 13 38V49L36 62ZM28.7756 55.6193C27.4809 54.0033 26.0717 52.3222 24.5958 50.6698C21.4553 47.1535 18.1125 43.8814 15 41.62V47.8331L28.7756 55.6193Z"
    />
  </svg>,
  'TecanSparkIcon'
);
